export const COPY = {
  left: {
    title: "Choose the right parcel solution",
    helpPrefix: "Need help choosing?",
    helpLink: "Let’s Collaborate.",
    restartLink: "Click here",
    restartSuffix: "to start over",
  },
  email: {
    title: "Contact Info",
    subtitle:
      "Use the fields below to connect with our team and ensure the best fit for your exact requirements.",
    skip: "Skip",
    cta: "Send",
    sending: "Sending…",
    failure: "We could not confirm your request. Please try again.",
    firstNamePlaceholder: "First name",
    lastNamePlaceholder: "Last name",
    companyPlaceholder: "Company name",
    cityPlaceholder: "City",
    statePlaceholder: "State",
    countryPlaceholder: "Country",
    placeholder: "your@email.com",
    invalid: "Please enter a valid email address.",
    firstNameRequired: "Please enter your first name.",
    lastNameRequired: "Please enter your last name.",
    companyRequired: "Please enter your company name.",
    cityRequired: "Please enter your city.",
    stateRequired: "Please enter your state.",
    countryRequired: "Please select your country.",
    required: "Please enter your email address.",
    thanks: "Thank you. A member of our team will be in touch with you soon.",
  },
  noMatch: {
    title: "No Match Found",
    body: "Placeholder: no products match the selected criteria.",
    cta: "Start Over",
  },
  results: {
    label: "INITIAL RECOMMENDATION",
    heading: "Initial Recommendation Overview",
    pairing: "Digital Product Pairing",
    learnMore: "Learn More",
    dataSheet: "Download Data Sheet",
    collaborate: "Collaborate with Our Team",
  },
} as const
